import React, { useEffect, useState } from 'react'
import './Branchprofiles.css'
import axios from 'axios';
import gallary from "../../imgs/gallary.png";
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { useNavigate } from 'react-router-dom';

const Branchprofiles = () => {
    const [DataSource, setDataSource] = useState([]);
    const [value, setValue] = useState('');
    const [tableFilter, setTableFilter] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        let formData = new FormData();
        formData.append('branchcode', localStorage.getItem("brno"));

        axios.post('https://softtesting.in/php/cust/getmyprofilesweb.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
            
                if(response.data)
                {
                    setDataSource(response.data);
                }
            })
            .catch(error => {
                // Handle any errors
                console.log(error);
            });
    }, [])


    const openprofile = (sr)=>{
        localStorage.setItem("sredit",sr)
        navigate("/newregi");
    }


    return (
        <div className='prlistmain'>
            <div className="prlistmainback">
                <span className='regularboldcolor'>प्रोफाईल यादी  -  {localStorage.getItem("bname")}</span>

                <table id="table-to-xls" className="table table-striped">
                    <thead>
                        <tr>
                            <th className='regularbold' scope="col">सिरीयल</th>
                            <th className='regularbold' scope="col">नाव</th>
                            <th className='regularbold' scope="col">पासवर्ड</th>
                            <th className='regularbold' scope="col">एक्शन</th>

                        </tr>
                    </thead>
                    <tbody>
                        {value.length > 0 ? tableFilter.map((user, index) =>
                            <tr key={index}>
                                <td>{user.sr}</td>
                                <td>{user.name}</td>
                                <td>{user.passyesno}</td>
                            </tr>
                        )
                            :
                             DataSource.map((user, index) =>
                                <tr key={index + 1}>
                
                                    <td>{user.sr}</td>
                                    <td>{user.name}</td>
                                    <td>{user.passyesno === "Yes" ? user.pass : user.passyesno}</td>
                                    <td><UilEditAlt onClick={() => openprofile(user.sr)}  className="ic"/></td>
                                </tr> 
                            ) 
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Branchprofiles
